import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import GamesSection from './components/GamesSection';
import AboutSection from './components/AboutSection';
import TrustSection from './components/TrustSection';
import PaymentBadgesSection from './components/PaymentBadgesSection';
import DepositsSection from './components/DepositsSection';
import RegisterGuideSection from './components/RegisterGuideSection';
import BonusSection from './components/BonusSection';
import BlogCtaSection from './components/BlogCtaSection';
import ProvidersAndFAQ from './components/ProvidersAndFAQ';

export default function HomePage() {
  return (
    <div className="min-h-screen site-bg font-sans overflow-x-hidden">
      <Navbar />
      <main className="pt-16 sm:pt-[4.5rem]">
        <AboutSection />
        <GamesSection />
        <TrustSection />
        <PaymentBadgesSection />
        <DepositsSection />
        <RegisterGuideSection />
        <BonusSection />
        <BlogCtaSection />
        <ProvidersAndFAQ />
      </main>
      <Footer />
    </div>
  );
}
